export default __webpack_public_path__ + "src/assets/fonts/BebasNeue Regular.ttf";